import { render, staticRenderFns } from "./CertificateDownload.vue?vue&type=template&id=6c5ad0a7&scoped=true&"
import script from "./CertificateDownload.vue?vue&type=script&lang=js&"
export * from "./CertificateDownload.vue?vue&type=script&lang=js&"
import style0 from "./CertificateDownload.vue?vue&type=style&index=0&id=6c5ad0a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5ad0a7",
  null
  
)

component.options.__file = "CertificateDownload.vue"
export default component.exports